"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegistryInfoPayload = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const field_1 = require("../../../../../openapi/field");
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy.Device.Factory.Schema';
exports.RegistryInfoPayload = effect_1.Schema.Struct({
    serialNumber: (0, field_1.nonEmpty)('Device serial number. The registry record is keyed by it.'),
    manufacturingSerialNumber: (0, field_1.optionalString)('Manufacturing serial number (MSN) of the unit'),
    sku: (0, field_1.optionalString)('SKU of the unit'),
    assetTag: (0, field_1.optionalString)('Asset tag of the unit'),
}).annotations({
    identifier: `${exports.NAMESPACE}.RegistryInfoPayload`,
    description: 'Registry information the factory records for a device',
});
//# sourceMappingURL=schema.js.map